<template>
  <v-card class="pa-4 text-center card-pad">
    <v-btn absolute top right icon small @click="$emit('close')" text>
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <h3 class="mb-4">
      <strong>
        {{ isEditing ? $t('Atualizar') : $t('Adicionar') }} classe
      </strong>
    </h3>

    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="12" class="text-start">
          <label>Nome</label>
          <v-text-field
            v-model="item.name"
            class="primary-input"
            outlined
            hide-details="auto"
            placeholder="Digite o nome da classe"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            class="secondary-button mr-0"
            depressed
            :loading="loading"
            @click="submit"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'ManageClass',

  props: {
    itemProp: Object,
  },

  data() {
    return {
      isEditing: false,
      item: {},
      apiService: new ApiService(),
      loading: false,
      institution: {},
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    if (this.itemProp && this.itemProp.id) {
      this.isEditing = true
      this.item = {
        ...this.itemProp,
        institutionId: this.institution.id,
      }
    }
  },

  methods: {
    add() {
      this.loading = true
      this.apiService
        .post('InspectionRoutineChecklistItemClass/add', this.item)
        .then((response) => {
          this.$toast.success('Classe adicionada com sucesso!')
          this.$emit('confirm')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true
      this.apiService
        .post('InspectionRoutineChecklistItemClass/edit', this.item)
        .then((response) => {
          this.$toast.success('Classe atualizada com sucesso!')
          this.$emit('confirm')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      this.item.institutionId = this.institution.id

      if (this.isEditing) this.edit()
      else this.add()
    },
  },
}
</script>

<style></style>
